import PropTypes from 'prop-types';

import { ClassNamePropTypes } from '@/common/proptypes/Base/ClassName.protypes';
import { ClassDefaultProps } from '@/materiaux/components/blocks/Discount/Class/Class.proptypes';

export const ItemDefaultProps = {
  ...ClassDefaultProps,
  hasBatches: false,
  batches: [],
  quantity: null,
  stock: {},
  unit: null,
  warehouse: null,
};

export const ItemPropTypes = {
  ...ClassNamePropTypes,
  hasBatches: PropTypes.bool,
  batches: PropTypes.arrayOf(PropTypes.shape({})),
  quantity: PropTypes.number,
  stock: PropTypes.shape({}),
  unit: PropTypes.string,
  warehouse: PropTypes.string,
};
